// metrics/webVitals.ts - Hook into web-vitals for performance metrics
import { getCLS, getFID, getLCP, getTTFB } from 'web-vitals';

function sendMetric(name: string, value: number) {
  const payload = {
    name,
    value,
    url: window.location.href,
    timestamp: Date.now()
  };

  // Log for now; optionally POST to a metrics endpoint
  if (process.env.REACT_APP_METRICS_URL) {
    try {
      fetch(process.env.REACT_APP_METRICS_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    } catch (err) {
      // noop
    }
  } else {
    // Fallback: console
    // eslint-disable-next-line no-console
    console.log('[web-vitals]', payload);
  }
}

export function initWebVitals() {
  getCLS((metric) => sendMetric(metric.name, metric.value));
  getFID((metric) => sendMetric(metric.name, metric.value));
  getLCP((metric) => sendMetric(metric.name, metric.value));
  getTTFB((metric) => sendMetric(metric.name, metric.value));
}
